import React from 'react';
import { hot } from 'react-hot-loader';

import styles from './styles.module.css';

const PageTitle = ({ children }) => {
  return (
    <h1 className={styles.title}>{children}</h1>
  );
};

export default hot(module)(PageTitle);
